import { Directive,forwardRef,Input } from '@angular/core';
import { Validator,NG_VALIDATORS,AbstractControl } from '@angular/forms';
import { isNull } from 'util';


@Directive({
  selector: '[validarIdentificacion]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => ValidarIdentificacionDirective),
    multi: true
  }]
})
export class ValidarIdentificacionDirective implements Validator {
  @Input() validarIdentificacion:any
  private validatorFn: Function;
  private onChange: Function;

  validate(control: AbstractControl) : {[key: string]: any} {
    /** Valida si contro no esta inicializado */
    if(isNull(control)) return  {nomatch: false}

    if(control.value == "") return  {nomatch: false}
    /** Valida si es Cedula o ruc y si solo son numeros caso contrario borra el caracter */
    if(!isNull(control.value) && this.validarIdentificacion != "3"  && !(/^[0-9]+$/.test(control.value)) ){
      control.setValue(control.value.slice(0, -1))
      return {nomatch: false}
    }
    /** Valida si es pasaporte y si solo son numeros y letras caso contrario borra el caracter */
    if(!isNull(control.value) && this.validarIdentificacion == "3"  && !(/^[0-9a-zA-Z]+$/.test(control.value)) ){
      control.setValue(control.value.slice(0, -1))
      return {nomatch: false}
    }

    /** Si el valor es != null llama a la funcion valida identificacion */
    console.log("Datos de entrada **-->", control.value, this.validarIdentificacion)
    if(control.value != null ) {
      console.log("respuestas validacion -->", this.identificacion(this.validarIdentificacion,control.value) ? null :{nomatch: false})
      return this.identificacion(this.validarIdentificacion,control.value) ? null :{nomatch: false}
    }



    return null
  }

  registerOnValidatorChange(fn: () => void) { this.onChange = fn; }

  public identificacion(tipo:any, identificacion:any){
    /** Tipo Cedula */
    if(tipo == "2"){

      if(identificacion.length !== 10) return false

      if(!(/^[0-9]+$/.test(identificacion))) return false
      return this.cedula(identificacion)
    }
    /** Tipo RUC */
    if(tipo == "1"){
      //console.log("RUC numero -->",identificacion.length)

      if(identificacion.length !== 13) return false
      if(!(/^[0-9]+$/.test(identificacion))) return false
      if(this.cedula(identificacion)) return true
      return this.ruc(identificacion)
    }
    /** Tipo Pasaporte */
    if(tipo == "3"){
      //console.log("tipo pasaporte -->", identificacion.length)
      //if(identificacion.length < 3) return false
      return true
    }
     /** Tipo Consumidor FInal */
    if(tipo == "4"){
      if(identificacion.length !== 13) return false
      if(!(/^[0-9]+$/.test(identificacion))) return false
      return this.consumidor(identificacion)
    }
    return true
  }

  /** Validar CONSUMIDOR FINAL */
  private consumidor(identificacion:string){
    let bandera = true
    for(let i = 0; i < 12; i++){
      let numero = parseInt(identificacion.substr(i,1))
      if(numero != 9) bandera = false
    }
    return bandera
  }

  /** Validacion MOD 10 */
  private cedula(identificacion:string){
    let sum = 0
    for(let i = 0; i < 9; i++){
      let numero = parseInt(identificacion.substr(i,1))
      if((i+1) % 2 == 0){
        sum = sum + numero
      }else{
        let valor = ( numero * 2 > 9 ) ? (numero * 2) - 9 : numero*2
        sum = sum + valor
      }
    }
    let validador = ((sum % 10) == 0 ) ? 0 : 10 -(sum % 10)
    return (validador == parseInt(identificacion.substr(9,1)))
  }

  /** Switch para validar el RUC por el tipo de consumidor */
  private ruc(identificacion:string){
    let contribuyente = parseInt(identificacion.substr(2,1))

    /** R.U.C. Persona natural */
    if(contribuyente < 6){
      console.log("Contribuyente", contribuyente)
      return this.cedula(identificacion)
    }
    /** R.U.C. Jurídicos y extranjeros sin cédula */
    if(contribuyente == 9){
      return this.mod11(identificacion,"432765432")
    }

    /** R.U.C. Públicos */
    if(contribuyente == 6){
      return this.mod11(identificacion,"32765432")
    }
  }

  /** Validacion con MOD 11 */
  private mod11(identificacion:string, coeficiente:string){
    let sum = 0
    for(let i = 0; i < 9; i++){
      sum = sum + (parseInt(identificacion.substr(i,1)) * parseInt(coeficiente.substr(i,1)))
    }
    let validador = ((sum % 11) == 0 ) ? 0 : 11 - (sum % 11)
    return (validador == parseInt(identificacion.substr(9,1)))
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directive/validar-identificacion.directive.ts